import CONSTANTS from "../../assets/js/Constants"

const phuTung = {
	loaiPhuTung: [],
	danhSachPhuTung: [],
	quang: []
}

export default function (state = phuTung, { type, payload }) {
	switch (type) {
		case CONSTANTS.ACTION.PHU_TUNG.SET_TYPE_PHU_TUNG:
			return { ...state, loaiPhuTung: payload}
			
		case CONSTANTS.ACTION.PHU_TUNG.SET_PHU_TUNG:
			// return { ...state, phuTung: payload}
			return { ...state, danhSachPhuTung: payload}
		
		case CONSTANTS.ACTION.PHU_TUNG.GET_LIST_PHU_TUNG:
			return { ...state, quang: payload}
			
		default:
			return { ...state }
	}
}

        
        
